var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSankey = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-.005-.005h16.01v16.01H-.005z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "m4.977 12.256-2.979.01.004 1.5 2.979-.01a3.75 3.75 0 0 0 3.21-1.83l1.053.757a5.75 5.75 0 0 0 3.358 1.082H14v-1.5h-1.398a4.25 4.25 0 0 1-2.482-.8l-1.316-.947.86-2.15.553.395a5.25 5.25 0 0 0 3.09.978l.702-.005-.018-2.5-.702.005a2.75 2.75 0 0 1-1.619-.512l-1.052-.752.325-.812a2.25 2.25 0 0 1 2.089-1.415H14v-1.5h-.968A3.75 3.75 0 0 0 9.55 4.61l-.188.47-2.07-1.478a7.25 7.25 0 0 0-4.215-1.35H2v2.5h1.077c.99 0 1.955.309 2.761.884L8.407 7.47l-.858 2.145-1.782-1.282a5.75 5.75 0 0 0-3.354-1.082h-.412L2 8.75h.412c.89 0 1.757.28 2.48.8l2.075 1.493a2.25 2.25 0 0 1-1.99 1.212Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSankey);
export default ForwardRef;